import { render, staticRenderFns } from "./LinkFileV3.vue?vue&type=template&id=07d568cd"
import script from "./LinkFileV3.vue?vue&type=script&lang=js"
export * from "./LinkFileV3.vue?vue&type=script&lang=js"
import style0 from "./LinkFileV3.vue?vue&type=style&index=0&id=07d568cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports